import type { Project } from '@/types';

export const PROJECTS: Project[] = [
  {
    id:             'rejean',
    name:           'Rejean — Alertes Quincailleries',
    description:    'PWA qui surveille les promotions dans les quincailleries de ta région et t\'alerte quand les matériaux de ton projet de rénovation sont en rabais. Matching IA matériaux × promotions.',
    accentColorVar: 'var(--color-anticiper)',
    tags:           ['PWA', 'Gemini API', 'Firebase FCM', 'i18n'],
  },
  {
    id:             'stackchan',
    name:           'StackChan Companion',
    description:    'Robot IoT open source sur ESP32 avec expressions faciales animées réagissant en temps réel aux événements Claude Code. Assistant physique sur le bureau.',
    accentColorVar: 'var(--color-ciel)',
    tags:           ['C++', 'ESP32-S3', 'PlatformIO', 'Open Source'],
  },
  {
    id:             'lecours',
    name:           'Lecours Érablière',
    description:    'Site vitrine et commandes en ligne pour l\'érablière familiale — produits, coffrets, commandes saisonnières. Un hommage bâti avec soin.',
    accentColorVar: 'var(--color-ameliorer)',
    tags:           ['Firebase Auth', 'Firestore', 'HTML · CSS · JS'],
  },
  {
    id:             'rpg-textuel',
    name:           'RPG Textuel — MJ propulsé par l\'IA',
    description:    'Jeu de rôle textuel solo façon D&D où le Maître du Jeu est une IA : elle narre et improvise, mais ne touche jamais aux règles — chaque effet passe par des événements validés par le moteur. Dés 3D, combats tactiques, quêtes, météo et monde persistant.',
    accentColorVar: 'var(--color-temps)',
    tags:           ['React · TS strict', 'Gemini API', 'Dés 3D', 'Open Source'],
  },
  {
    id:             'sorel-techno',
    name:           'Sorel Techno — Regroupement tech de Sorel-Tracy',
    description:    'Site web du regroupement technologique de Sorel-Tracy, un collectif en démarrage qui rassemble les acteurs tech de la région. Site statique rapide et accessible, conforme à la Loi 25, hébergé sur Firebase.',
    accentColorVar: 'var(--color-anticiper)',
    tags:           ['HTML · CSS · JS', 'Firebase Hosting', 'Accessibilité', 'En démarrage'],
    link:           'https://sorel-techno.web.app',
    logoSrc:        '/sorel-techno-logo.svg',
  },
  {
    id:             'petitchef',
    name:           'Petit Chef',
    description:    'App qui compare les prix des aliments dans les épiceries de ta région, identifie les meilleures offres et propose des recettes intelligentes avec les ingrédients les moins chers.',
    accentColorVar: 'var(--color-maitrise)',
    tags:           ['React Native', 'IA', 'Firebase', 'WIP'],
  },
];
